import * as React from 'react';
import AnimateHeight, { AnimateHeightProps } from 'react-animate-height';

/**
 * Wrapper for AnimateHeight which sets the duration to a small value when running tests.
 */
export default (props: AnimateHeightProps) => {
  return (
    <AnimateHeight
      {...props}
      duration={process.env.REACT_APP_ENV === 'test' ? 10 : props.duration}
    />
  );
};



// WEBPACK FOOTER //
// ./src/app/components/Utils/AnimateHeight/index.tsx